<h1 class="h5">Notifications (0)</h1>
<div class="toast-container w-100 position-static">
  <!-- Toast Items -->
<!--  <div class="toast border-0 w-100 show" role="alert" aria-live="assertive" aria-atomic="true">-->
<!--    <div class="toast-header">-->
<!--      <img src="images/sun.webp" class="rounded me-2" alt="...">-->
<!--      <strong class="me-auto">GizmoAffiliates</strong>-->
<!--      <small class="text-muted">just now</small>-->
<!--      <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>-->
<!--    </div>-->
<!--    <div class="toast-body">-->
<!--      <p class="mb-0"><strong><i class="bi bi-bell-fill text-primary me-2"></i>New Offer Available</strong><br>-->
<!--        A new exclusive offer has been added to your dashboard.</p>-->
<!--    </div>-->
<!--  </div>-->

<!--  <div class="toast border-0 w-100 show" role="alert" aria-live="assertive" aria-atomic="true">-->
<!--    <div class="toast-header">-->
<!--      <img src="images/sun.webp" class="rounded me-2" alt="...">-->
<!--      <strong class="me-auto">GizmoAffiliates</strong>-->
<!--      <small class="text-muted">2 seconds ago</small>-->
<!--      <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>-->
<!--    </div>-->
<!--    <div class="toast-body">-->
<!--      <p class="mb-0"><strong><i class="bi bi-wallet2 text-success me-2"></i>Payment Processed</strong><br>-->
<!--        Your latest payment has been successfully processed.</p>-->
<!--    </div>-->
<!--  </div>-->

<!--  <div class="toast border-0 w-100 show" role="alert" aria-live="assertive" aria-atomic="true">-->
<!--    <div class="toast-header">-->
<!--      <img src="images/sun.webp" class="rounded me-2" alt="...">-->
<!--      <strong class="me-auto">GizmoAffiliates</strong>-->
<!--      <small class="text-muted">6 minutes ago</small>-->
<!--      <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>-->
<!--    </div>-->
<!--    <div class="toast-body">-->
<!--      <p class="mb-0"><strong><i class="bi bi-envelope-fill text-warning me-2"></i>New Message from Support</strong><br>-->
<!--        You have received a new message regarding your recent inquiry.</p>-->
<!--    </div>-->
<!--  </div>-->

<!--  <div class="toast border-0 w-100 show" role="alert" aria-live="assertive" aria-atomic="true">-->
<!--    <div class="toast-header">-->
<!--      <img src="images/sun.webp" class="rounded me-2" alt="...">-->
<!--      <strong class="me-auto">GizmoAffiliates</strong>-->
<!--      <small class="text-muted">2 days ago</small>-->
<!--      <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>-->
<!--    </div>-->
<!--    <div class="toast-body">-->
<!--      <p class="mb-0"><strong><i class="bi bi-star-fill text-danger me-2"></i>Special Partner Offer</strong><br>-->
<!--        Check out this exclusive deal from our trusted partners.</p>-->
<!--    </div>-->
<!--  </div>-->

<!--  <div class="toast border-0 w-100 show" role="alert" aria-live="assertive" aria-atomic="true">-->
<!--    <div class="toast-header">-->
<!--      <img src="images/sun.webp" class="rounded me-2" alt="...">-->
<!--      <strong class="me-auto">GizmoAffiliates</strong>-->
<!--      <small class="text-muted">3 days ago</small>-->
<!--      <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>-->
<!--    </div>-->
<!--    <div class="toast-body">-->
<!--      <p class="mb-0"><strong><i class="bi bi-gift-fill text-info me-2"></i>Limited-Time Bonus</strong><br>-->
<!--        Don't miss out on this special bonus available for a short time.</p>-->
<!--    </div>-->
<!--  </div>-->

<!--  <div class="toast border-0 w-100 show" role="alert" aria-live="assertive" aria-atomic="true">-->
<!--    <div class="toast-header">-->
<!--      <img src="images/sun.webp" class="rounded me-2" alt="...">-->
<!--      <strong class="me-auto">GizmoAffiliates</strong>-->
<!--      <small class="text-muted">4 days ago</small>-->
<!--      <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>-->
<!--    </div>-->
<!--    <div class="toast-body">-->
<!--      <p class="mb-0"><strong><i class="bi bi-people-fill text-primary me-2"></i>New Referral</strong><br>-->
<!--        You have a new referral in your network. Check your dashboard for details.</p>-->
<!--    </div>-->
<!--  </div>-->

<!--  <div class="toast border-0 w-100 show" role="alert" aria-live="assertive" aria-atomic="true">-->
<!--    <div class="toast-header">-->
<!--      <img src="images/sun.webp" class="rounded me-2" alt="...">-->
<!--      <strong class="me-auto">GizmoAffiliates</strong>-->
<!--      <small class="text-muted">6 days ago</small>-->
<!--      <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>-->
<!--    </div>-->
<!--    <div class="toast-body">-->
<!--      <p class="mb-0"><strong><i class="bi bi-patch-check-fill text-success me-2"></i>Account Verified</strong><br>-->
<!--        Your account verification has been successfully completed.</p>-->
<!--    </div>-->
<!--  </div>-->

</div>
